import { Typography } from '@material-ui/core'
import * as React from 'react'

// type Img = any

import classnames from 'classnames'
import ReactSVG from 'react-svg'
import SendIcon from '../../../assets/img/send.svg'

interface IProps {
  title: string
  description: string
  // completedImages: Img[]
  // pendingImages: Img[]
  onClick?: () => void
  plusUser: boolean
  onSend?: (e: React.MouseEvent) => void
  responseMissing?: boolean
}
interface IState {}

class Content extends React.Component<IProps, IState> {
  render() {
    const {
      title,
      description,
      // completedImages,
      // pendingImages,
      onClick,
      onSend,
      plusUser,
      responseMissing
    } = this.props

    return (
      <div
        className={classnames('patient-form', { clickable: onClick })}
        onClick={onClick}
      >
        {responseMissing && (
          <Typography className="response-msg">
            Missing parent response
          </Typography>
        )}
        <div
          className={
            'patient-form-content' +
            (responseMissing ? ' response-missing' : '')
          }
        >
          <div className="details">
            <Typography className="title" component={'span'}>
              {title}
              {!plusUser && (
                <ReactSVG
                  className="locked-indicator"
                  src={require('../../../assets/img/crown.svg')}
                />
              )}
            </Typography>
            <Typography className="description">{description}</Typography>
          </div>
          <div className="info-container">
            {/* {pendingImages.length > 0 && (
              <div className="parents pending-parents">
                <div className="parents-images">
                  {pendingImages.map((img, i) => (
                    <div className="parent-image-container" key={i}>
                      <img className="parent-image" src={img} alt="" />
                    </div>
                  ))}
                </div>
                <Typography className="label">Waiting</Typography>
              </div>
            )} */}
            {/* {completedImages.length > 0 && (
              <div className="parents completed-parents">
                <div className="parents-images">
                  {completedImages.map((img, i) => {
                    return (
                      <div className="parent-image-container" key={i}>
                        <img
                          key={i}
                          className="parent-image"
                          src={img}
                          alt=""
                        />
                      </div>
                    )
                  })}
                </div>
                <Typography className="label">Completed</Typography>
              </div>
            )} */}
            <div className="send" onClick={onSend}>
              <div className="send-image-container">
                <ReactSVG className="send-img" src={SendIcon} />
              </div>
              <Typography className="label">Share</Typography>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Content



// WEBPACK FOOTER //
// ./src/pages/EvaluationQuestionnaires/PatientForm/content.tsx